<template>
  <section class="cheques-container">
    <h3>Cheques</h3>
    <div class="abs-top-right">
      <v-button
        :disabled="disabledBtn"
        @click="handlerClearSelection">Clear Selection</v-button>
      <v-button
        type="danger"
        :disabled="disabledBtn"
        @click="deleteSelection">Delete Cheque</v-button>
      <v-button
        type="primary"
        :disabled="disabledBtn"
        @click="markDoneSelection">Mark As Done</v-button>
    </div>
    <div class="transparent">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="id"
          label="ID"></el-table-column>
        <el-table-column
          prop="name"
          label="Name"></el-table-column>
        <el-table-column
          prop="amount"
          label="Amount"></el-table-column>
        <el-table-column
          prop="created_on"
          label="Created On"></el-table-column>
        <el-table-column
          prop="status"
          label="Status"></el-table-column>
      </el-table>
    </div>
  </section>
</template>
<script>
import { deleteCheque, markDoneCheque } from '@/api/cheque'
export default {
  name: 'Cheques',
  props: {
    cheques: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      selectionList: [],
      tableData: []
    }
  },
  computed: {
    disabledBtn() {
      return this.selectionList.length <= 0
    },
    idResultList() {
      const selectList = this.selectionList.reduce((result, item) => {
        result.push(item.id)
        return result
      }, [])
      return selectList
    }
  },
  watch: {
    cheques: {
      immediate: true,
      deep: true,
      handler(val) {
        this.tableData = JSON.parse(JSON.stringify(val))
      }
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.selectionList = val
    },
    handlerClearSelection() {
      this.$refs.table.clearSelection()
    },
    markDoneSelection() {
      if(this.idResultList.length < 1) {
        return
      }
      this.network().markDoneCheque()
    },
    deleteSelection() {
      // todo
      if(this.selectionList.length < 1) {
        return
      }
      this.network().deleteCheque()
    },
    network() {
      return {
        deleteCheque: async () => {
          const { data } = await deleteCheque({
            id: this.idResultList
          })
          this.$emit('update')
        },
        markDoneCheque: async () => {
          const { data } = await markDoneCheque({
            cheque_id: this.idResultList
          })
          this.$emit('update')
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.cheques-container {
    position: relative;
    // padding-top: 15px;
    .abs-top-right {
        padding-top: 5px;
    }
    .transparent {
        margin-top: 15px;
    }
}
</style>